import { Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from '@bemap/ui';
import { ADMIN_ROUTES } from '@bemap/utils';
import AdminPage from '../pages/admin/admin-page';
import PartnersPage from '../pages/partners/partners-page';
import UsersPage from '../pages/users/users-page';
import AnalystsPage from '../pages/analysts/analysts-page';
import ViewAnalystPage from '../pages/analysts/view-analyst';
import InvoiceList from '../pages/invoices/list-invoices';
import WordsPage from '../pages/words/words-page';
import UniversityPage from '../pages/university/university-page';
import CoursesListPage from '../pages/university/courses/courses-list';
import CreateCoursePage from '../pages/university/courses/create-course';
import ViewCoursePage from '../pages/university/courses/view-course';
import ViewContentPage from '../pages/university/courses/view-content';
import StudentsListPage from '../pages/university/courses/students-list';
import SelectContentTypePage from '../pages/university/courses/select-content-type';
import CreateVideoContentPage from '../pages/university/courses/create-video-content';
import CreateDocumentContentPage from '../pages/university/courses/create-document-content';
import CreateQuizContentPage from '../pages/university/courses/create-quiz-content';
import { ISession } from '@bemap/utils';
import { FC } from 'react';
import EditCoursePage from '@/pages/university/courses/edit-course';
import EditDocumentContentPage from '@/pages/university/courses/modules/content/edit-document-content';
import CertificatesPage from '@/pages/certificates/certificates-page';
import EditVideoContentPage from '@/pages/university/courses/modules/content/edit-video-content';
import EditQuizContentPage from '@/pages/university/courses/modules/content/edit-quiz-content';

const appVersion = __APP_VERSION__

interface ProtectedLayoutProps {
  user: ISession | null;
}

const ProtectedRoutes: FC<ProtectedLayoutProps> = ({ user }) => {

  return (
    <Dashboard user={user} appVersion={appVersion}>
      <Routes>
        <Route path="/" element={<Navigate to={ADMIN_ROUTES.DASHBOARD} replace />} />
        <Route path={ADMIN_ROUTES.DASHBOARD} element={<AdminPage />} />
        <Route path={ADMIN_ROUTES.ASSESSMENTS_DASHBOARD} element={<AdminPage />} />
        <Route path={ADMIN_ROUTES.PARTNERS} element={<PartnersPage />} />
        <Route path={ADMIN_ROUTES.USERS} element={<UsersPage />} />
        <Route path={ADMIN_ROUTES.ASSESSMENTS} element={<UsersPage />} />
        <Route path={ADMIN_ROUTES.ANALYSTS} element={<AnalystsPage />} />
        <Route path={ADMIN_ROUTES.VIEW_ANALYST} element={<ViewAnalystPage />} />
        <Route path={ADMIN_ROUTES.CRM} element={<UsersPage />} />
        <Route path={ADMIN_ROUTES.INVOICES} element={<InvoiceList />} />
        <Route path={ADMIN_ROUTES.WORDS} element={<WordsPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY} element={<UniversityPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES} element={<CoursesListPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_CREATE} element={<CreateCoursePage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_VIEW} element={<ViewCoursePage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_EDIT} element={<EditCoursePage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_MODULE_CONTENT_VIEW} element={<ViewContentPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_MODULE_CONTENT_SELECT} element={<SelectContentTypePage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_MODULE_CONTENT_VIDEO_CREATE} element={<CreateVideoContentPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_MODULE_CONTENT_VIDEO_EDIT} element={<EditVideoContentPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_MODULE_CONTENT_DOCUMENT_CREATE} element={<CreateDocumentContentPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_MODULE_CONTENT_DOCUMENT_EDIT} element={<EditDocumentContentPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_MODULE_CONTENT_QUIZ_CREATE} element={<CreateQuizContentPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_COURSES_MODULE_CONTENT_QUIZ_EDIT} element={<EditQuizContentPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_STUDENTS} element={<StudentsListPage />} />
        <Route path={ADMIN_ROUTES.UNIVERSITY_CERTIFICATES} element={<CertificatesPage />} />
        <Route path="*" element={<Navigate to={ADMIN_ROUTES.DASHBOARD} replace />} />
      </Routes>
    </Dashboard>
  );
};

export default ProtectedRoutes; 